<template>
  <tr class="table__row">
    <td class="table__cell">
      <div class="h-bold-text">{{ location.name }}</div>
      <div>{{ location.street }}</div>
      <div>{{ location.city }}, {{ location.state }} {{ location.zip }}</div>
      <div>{{ location.phone }}</div>
    </td>
    <td class="table__cell h-center-align" v-for="vendor in vendors" :key="vendor">
      <VendorAccount :vendor="vendor" :accounts="accounts"></VendorAccount>
    </td>
  </tr>
</template>

<script>

  import VendorAccount from './VendorAccount.vue';

  export default {
    name: 'Location',
    components: {
      VendorAccount
    },
    props: {
      location: {
        type: Object,
      },
      accounts: {
        type: Array,
      },
    },
    data() {
      return {
        vendors: ['oticon', 'resound', 'signia', 'sonic', 'starkey', 'widex'],
      };
    },
  }
</script>

